import React, { useContext } from 'react';
import { Nav, Navbar, Button, Container, Row, Col, Card } from 'react-bootstrap';
import classnames from 'classnames';
import tabs from '../../../constants/navTabs';
import { BusinessContext } from '../../../contexts/business';
import { useHistory } from 'react-router';

const chunk = (array, n) => {
    if (!array.length) {
        return [];
    }

    return [array.slice(0, n)].concat(chunk(array.slice(n), n));
};

const About = () => {
    return (
        <section
            className={classnames('section-about')}
        >
            <Container>
                <Row>
                    <Col>
                        <div className="section-about__card">
                            <h2 className="heading-section mb-6">Vision</h2>
                            <div className="section-about__content">
                                <p>To be known as a market leader in creating mutual benefit for buyers, sellers and society as a whole.</p>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className="section-about__card">
                            <h2 className="heading-section mb-6">Mission</h2>
                            <div className="section-about__content">
                                <p>To create a market place where everyone is excited, participating and benefiting from economic activities.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

const Philosophy = () => {
    return (
        <section
            className={classnames('section-philosophy')}
        >
            <Row className="mb-6">
                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-bullhorn section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Market your product</h4>
                    </div>
                </Col>

                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-child section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Motivate customers</h4>
                    </div>
                </Col>

                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-handshake section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Manage sales channels</h4>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-sliders-h section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Maintain business</h4>
                    </div>
                </Col>

                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-people-carry section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Mutual benefit creation</h4>
                    </div>
                </Col>

                <Col sm={12} md={4}>
                    <div className="section-philosophy__item">
                        <i className="fas fa-hand-holding-heart section-philosophy__icon"></i>
                        <h4 className="section-philosophy__heading">Make contribution in the society – Charity</h4>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

const Services = () => {
    return (
        <section
            className={classnames('section-services')}
        >
            <Container>
                <div>
                    <ul className="section-services__list">
                        <li className="section-services__item">Enabling small and medium businesses to run their own sales program</li>
                        <li className="section-services__item">Marketing for business and motivating customers</li>
                        <li className="section-services__item">Customers engagement program</li>
                        <li className="section-services__item">Mutual benefit creation for buyers and sellers</li>
                    </ul>
                </div>
            </Container>
        </section>
    )
}

const Works = () => {
    const { businessCategories } = useContext(BusinessContext);
    const multipleCategories = chunk(businessCategories, 4);
    console.log('multipleCategories: ', multipleCategories);
    const history = useHistory();

    return (
        <section
            className={classnames('section-services')}
        >
            {/* <Container> */}
            {multipleCategories.map(cat => (
                <Row>
                    {cat.map(ct => (
                        <Col md={3}>
                            <ul className="section-services__list">
                                <li className="section-services__item section-services__item--small" onClick={() => history.push(`/businessCategoryDetail/${ct.id}`)}>{ct.title}</li>
                            </ul>
                        </Col>
                    ))}
                </Row>
            ))}
            {/* <Row>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Restaurants</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Hotels</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Clothing and Fashion</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Construction</li>
                    </ul>
                </Col>
            </Row>

            <Row>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Grocery shop</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Electronics and phones</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Book store</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Cosmetics and beauty</li>
                    </ul>
                </Col>
            </Row>

            <Row>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Real estate</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Automobiles</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Transportation</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Child care products</li>
                    </ul>
                </Col>

            </Row>

            <Row>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Telecom</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Pharmacy</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Health care institutes</li>
                    </ul>
                </Col>
                <Col>
                    <ul className="section-services__list">
                        <li className="section-services__item section-services__item--small">Other</li>
                    </ul>
                </Col>
            </Row> */}
            {/* <div>
                    <ul className="section-services__list">
                        <li className="section-services__item">Restaurants, Hotels, Clothing and Fashion, Construction and home improvement material</li>
                        <li className="section-services__item">Grocery shop, Electronics and phones, Book store, Cosmetics and beauty</li>
                        <li className="section-services__item">Real estate, Automobiles, Transportation</li>
                        <li className="section-services__item">Child care products, Pharmacy, Health care institutes</li>
                    </ul>
                </div> */}
            {/* </Container> */}
        </section>
    )
}

const DrawerContent = ({ tab }) => {
    switch (tab) {
        case tabs.ABOUT:
            return <About />;
        case tabs.PHILOSOPHY:
            return <Philosophy />;
        case tabs.SERVICES:
            return <Services />;
        case tabs.WORK:
            return <Works />;
        default:
            return <></>;
    }
}

export default DrawerContent;